import React, { useState, useCallback, useMemo } from 'react';
import T from '../../../../common/components/T';

import { TbodyComponent, TrComponent, TdComponent } from '../wrappers';
import css from './GridTbody.module.scss';
import { generateStylers } from '../../../../common/utils/styles';
import TrGridBody from './Components/TrGridBody/TrGridBody';
import TdGridComponent from './Components/TdGridComponent/TdGridComponent';
import classNames from 'classnames';

const GridTbody = ({
    tableData,
    setGridData,
    thead,
    widthArr,
    variant,
    openSwitcher,
    handlers = {},
    viewData,
    gridStyles = {},
    sticky,
    refTable,
    gridName,
    refTableChild,
    translation,
    emptyDataText,
    fixedLastColumnShow,
    isFixedLastColumnShow,
    isFixedColumn
}) => {
    const tbody = useMemo(() => tableData?.data || [], [tableData?.data]);
    const [activeTr, setActiveTr] = useState(false);
    const getHandlersTR = useCallback(
        (rowData) => {
            if (!(handlers?.tr && Object.keys(handlers.tr).length && rowData)) return {};

            return Object.keys(handlers.tr).reduce((accum, handlerName) => {
                accum[handlerName] = () => handlers.tr[handlerName](rowData, setGridData);
                return accum;
            }, {});
        },
        [handlers?.tr, setGridData]
    );

    const getHandlersTD = useCallback(
        (rowData, cellData, index, cellIndex) => {
            if (!(handlers?.td && handlers.td[cellIndex] && Object.keys(handlers.td[cellIndex]).length && rowData)) return {};

            return Object.keys(handlers.td[cellIndex]).reduce((accum, handlerName) => {
                accum[handlerName] = () => handlers.td[cellIndex][handlerName](rowData, cellData, index, cellIndex, setGridData);
                return accum;
            }, {});
        },
        [handlers?.td, setGridData]
    );

    const lineOffsetCalc = useCallback(
        (index) => {
            if (!tbody[index - 1]) {
                return 1;
            }
            let count = 1;
            const newArray = tbody.slice(0, index).reverse();
            for (let i = 0; i <= newArray.length; i++) {
                if (newArray[i] && newArray[i].depth > tbody[index].depth) {
                    count++;
                } else {
                    break;
                }
            }
            return count;
        },
        [tbody]
    );

    const margin = useCallback(
        (level) => {
            if (!!level && level >= 0 && variant !== 2) {
                return { marginLeft: `${level * 44}px` };
            }
            return {};
        },
        [variant]
    );

    const trStyle = generateStylers(gridStyles?.tr);
    const noDataStyle = generateStylers(gridStyles?.noDataStyle);

    const tdProps = {
        activeTr,
        fixedLastColumnShow,
        getHandlersTD,
        gridName,
        gridStyles,
        handlers,
        isFixedLastColumnShow,
        lineOffsetCalc,
        margin,
        openSwitcher,
        refTable,
        refTableChild,
        setActiveTr,
        setGridData,
        sticky,
        tbody,
        thead,
        translation,
        variant,
        viewData,
        widthArr,
        isFixedColumn
    };
    return (
        <TbodyComponent sticky={sticky}>
            {tbody?.length === 0 && (
                <TrComponent sticky={sticky}>
                    <TdComponent sticky={sticky} className={classNames(css.noData, noDataStyle.className)} colSpan={99999}>
                        {emptyDataText ? emptyDataText : <T textName='gridNoData' defaultStr='Нет данных' page='all' />}
                    </TdComponent>
                </TrComponent>
            )}
            {tbody.map((rowData, index) => (
                <TrGridBody
                    key={index}
                    sticky={sticky}
                    handlersTR={getHandlersTR(rowData)}
                    trStyle={trStyle}
                    tr={gridStyles?.tr}
                    o={rowData}
                    callbackfn={(cellData, cellIndex) => (
                        <TdGridComponent
                            key={`${cellIndex}-${index}`}
                            cellIndex={cellIndex}
                            cellData={cellData}
                            index={index}
                            rowData={rowData}
                            {...tdProps}
                        />
                    )}
                />
            ))}
        </TbodyComponent>
    );
};

export default GridTbody;
